import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import StockGalleryView from '../components/stock-gallery-view';
import createIstockApiAdapter from '../adapters/istock-api-adapter';
import useGallery from '../hooks/use-gallery';

function IstockGalleryContainer({
  sharedSearchQuery,
  multiple = false,
  isActive = true,
  isMobile = false,
  onFocus = Function.prototype,
  updateSelectedItems = Function.prototype,
  updateSearchQuery,
  onSearchEnd = Function.prototype,
  onLoadError = Function.prototype,
  getInitialSearchQuery,
}) {
  const apiAdapter = useMemo(() => createIstockApiAdapter(), []);

  const {
    items,
    isLoading,
    isSearching,
    isNotFound,
    handleSearch,
    handleSelect,
    handleLoadMoreItems,
  } = useGallery({
    apiAdapter,
    searchQuery: sharedSearchQuery,
    multiple,
    isActive,
    updateSelectedItems,
    updateSearchQuery,
    onSearchEnd,
    onLoadError,
    getInitialSearchQuery,
  });

  return (
    <StockGalleryView
      items={items}
      searchQuery={sharedSearchQuery || ''}
      searchPlaceholder={i18next.t('Search')}
      isNotFound={isNotFound}
      isLoading={isLoading}
      isMobile={isMobile}
      isSearching={isSearching}
      onSearch={handleSearch}
      onFocus={onFocus}
      onLoadMoreItems={handleLoadMoreItems}
      onItemClick={handleSelect}
    />
  );
}

IstockGalleryContainer.propTypes = {
  sharedSearchQuery: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]).isRequired,
  multiple: PropTypes.bool,
  isActive: PropTypes.bool,
  isMobile: PropTypes.bool,
  onFocus: PropTypes.func,
  updateSelectedItems: PropTypes.func,
  updateSearchQuery: PropTypes.func.isRequired,
  onSearchEnd: PropTypes.func,
  onLoadError: PropTypes.func,
  getInitialSearchQuery: PropTypes.func.isRequired,
};

export default IstockGalleryContainer;
